/**
 * Presety komunikacji w plazie.
 *
 * To nie jest pełny chat. Gracz wybiera z krótkiej, allowlistowanej listy
 * komunikatów, a realtime serwer waliduje `id` zanim pokaże bubble innym.
 * Tekst renderujemy runtime nad awatarem, więc PNG nie zawierają liter/liczb
 * (zgodne z workflow UI icon prompts).
 */

export type PlazaCommsPresetId =
  | 'hi'
  | 'trade'
  | 'sixty_seven'
  | 'looking_for_pet'
  | 'nice_pet'
  | 'thanks'
  | 'ready'
  | 'follow';

export interface PlazaCommsPreset {
  id: PlazaCommsPresetId;
  label: string;
  bubbleText: string;
  iconKey: string;
  color: {
    fill: number;
    stroke: number;
    text: string;
  };
  /** Trade jest zablokowany dla gościa zgodnie z D16. */
  requiresFullAccount?: boolean;
}

export const PLAZA_COMMS_DURATION_MS = 3600;

export const PLAZA_COMMS_PRESETS: readonly PlazaCommsPreset[] = [
  {
    id: 'hi',
    label: 'Hi!',
    bubbleText: 'Hi!',
    iconKey: 'ui_btn_comms',
    color: { fill: 0xffffff, stroke: 0x4f8fd8, text: '#1f4f7a' },
  },
  {
    id: 'trade',
    label: 'Trade',
    bubbleText: 'TRADE',
    iconKey: 'ui_btn_trade',
    color: { fill: 0xfff3dc, stroke: 0xf39c12, text: '#7a4300' },
    requiresFullAccount: true,
  },
  {
    id: 'sixty_seven',
    label: '67',
    bubbleText: '67',
    iconKey: 'ui_comm_fun',
    color: { fill: 0xf7ecff, stroke: 0xa855f7, text: '#5b21b6' },
  },
  {
    id: 'looking_for_pet',
    label: 'Szukam',
    bubbleText: 'Szukam peta',
    iconKey: 'ui_comm_pet_wanted',
    color: { fill: 0xeafff0, stroke: 0x32c658, text: '#146c2e' },
  },
  {
    id: 'nice_pet',
    label: 'Fajny pet',
    bubbleText: 'Fajny pet!',
    iconKey: 'ui_sparkle',
    color: { fill: 0xfffbdf, stroke: 0xffc93c, text: '#765300' },
  },
  {
    id: 'thanks',
    label: 'Dzięki',
    bubbleText: 'Dzięki!',
    iconKey: 'ui_comm_thanks',
    color: { fill: 0xeaf4ff, stroke: 0x5b8def, text: '#1e3f7a' },
  },
  {
    id: 'ready',
    label: 'OK',
    bubbleText: 'OK!',
    iconKey: 'ui_btn_confirm',
    color: { fill: 0xeafff0, stroke: 0x32c658, text: '#146c2e' },
  },
  {
    id: 'follow',
    label: 'Chodź',
    bubbleText: 'Chodź',
    iconKey: 'ui_comm_follow',
    color: { fill: 0xfff0f4, stroke: 0xff6fae, text: '#8a2357' },
  },
] as const;

export const PLAZA_COMMS_PRESETS_BY_ID: Record<PlazaCommsPresetId, PlazaCommsPreset> =
  Object.fromEntries(PLAZA_COMMS_PRESETS.map((p) => [p.id, p])) as Record<
    PlazaCommsPresetId,
    PlazaCommsPreset
  >;

export const PLAZA_COMMS_ICON_KEYS = Array.from(
  new Set(PLAZA_COMMS_PRESETS.map((p) => p.iconKey)),
);
